import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { ErrorBoundary } from "react-error-boundary";
import ErrorFallback from "./components/global/ErrorFallback";
import './locales/i18n';
import { SnackbarProvider } from 'notistack';
import reportWebVitals from './reportWebVitals';
import { HelmetProvider } from 'react-helmet-async';
import { PWAInstallProvider } from './context/PWAInstallContext';
import './index.css';  

// تسجيل الـ Service Worker
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/firebase-messaging-sw.js')
      .then((registration) => {
      })
      .catch((error) => {
        console.error('Service Worker registration failed:', error);
      });
  });
}
if (navigator.setAppBadge) {
}

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <PWAInstallProvider>
      <ErrorBoundary
        FallbackComponent={ErrorFallback}
        onReset={() => window.location.replace("/")}>
        <SnackbarProvider anchorOrigin={{ vertical: 'top', horizontal: 'right' }} >
          <HelmetProvider>
            <App />
          </HelmetProvider>
        </SnackbarProvider>
      </ErrorBoundary>
    </PWAInstallProvider>
  </React.StrictMode>
);
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
